export default __webpack_public_path__ + "static/media/babysit.b79d1e87.jpg";